const VISIT_KEY = 'tron_checklist_ads_visit';
let currentVisit = false;

export function hasGoogleAdSignal(search: string): boolean {
  const params = new URLSearchParams(search);
  return ['gclid', 'gbraid', 'wbraid', 'gad_campaignid'].some(key => Boolean(params.get(key))) ||
    (params.get('utm_source')?.toLowerCase() === 'google' && /^(cpc|ppc|paid|paid_search)$/i.test(params.get('utm_medium') || ''));
}

/** Separate from 90-day attribution: the current tab visit expires after 30 minutes idle. */
export function captureChecklistVisit(): void {
  if (typeof window === 'undefined') return;
  try {
    const stored = JSON.parse(sessionStorage.getItem(VISIT_KEY) || 'null');
    currentVisit = hasGoogleAdSignal(window.location.search) || Boolean(stored?.ads && Date.now() - stored.at < 30 * 60 * 1000);
    sessionStorage.setItem(VISIT_KEY, JSON.stringify({ ads: currentVisit, at: Date.now() }));
  } catch { currentVisit = currentVisit || hasGoogleAdSignal(window.location.search); }
}

export function checklistGoogleAdsVisit(): 'yes' | 'no' {
  captureChecklistVisit();
  return currentVisit ? 'yes' : 'no';
}